<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :labelCancel="labelCancel"
    labelBack="Atrás"
    :storeName="storeName"
    parentStoreName="Providers"
    parentUrlKey="user_id"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            
          </v-row>
          <v-row>
            
          </v-row>
        </v-col>
      </v-row>
      
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
        status: state => state.Reviews.status,
      })
    },
    data() {
      return {
        storeName: 'Reviews',
        title: "Reseñas",
        parentStoreName:'providers',
        parentUrlKey:'user_id',
        data: {
          name: '',
          order: '',
          property_id: '',
        }
      }
    },
    created() {
      
    },
  }
</script>
